// Màn hình bot ngay trên thẻ bot (gộp trang "Xem trực tiếp" cũ — người dùng chốt 05/10/2026). Mỗi ô: gửi `watch on` → máy chủ bảo bot chụp và
// chuyển `frame` về; <img> đổi src theo khung; nhãn "N khung/giây"; frame.error → chữ lỗi rõ; bot ngoại tuyến → chữ báo, ô vẫn giữ (máy chủ tự gửi lại
// view.start khi bot trực tuyến lại); WS nối lại → gửi lại `watch on`; rời trang / đóng tab → `watch off` cho mọi ô. Nút mờ ở góc ô = phóng to gấp 3.
// Tập ô đang xem là trạng thái của MỘT bộ điều khiển (XemHinh) do trang Bot tạo — thẻ bot vẽ lại thì chỉ gắn lại phần tử ô, không mất hình.
// 06/10/2026 (giao diện "máy tính"): KHÔNG còn nút Xem / Tắt hình / Tắt hết hình — bot trực tuyến CỦA MÌNH luôn tự mở hình; bot của chủ khác chỉ mở khi người
// dùng bấm "Xem bot của <chủ>" ngay trong khung màn hình (có ý thức, từng bot) và có nút nhỏ "Ẩn" để đóng lại. Nhiều ô (> NGUONG_NHIEU_O): ô NGOÀI khung nhìn
// (IntersectionObserver) báo máy chủ "watch.cham" → hạ còn 1 khung/giây; vào lại khung nhìn thì về tốc độ thường.
import { h } from "../dom";
import { KHOA_TAT_TU_BAT, NhoLuaChon } from "../logic-man-hinh";
import type { Bot } from "../types";
import { uiSocket } from "../ws";

export const LIVE_ERROR_TEXT = "Không có hình: cửa sổ bot đang thu nhỏ hoặc tab không hiển thị";
// Bot rớt mạng khi đang xem: giữ ô (máy chủ tự gửi lại view.start khi bot trực tuyến lại — server/src/live.ts onPresence),
// chỉ báo rõ thay vì để ô đứng "chờ khung hình…" im lặng. Không tự đóng ô: rớt mạng vài giây không được làm mất lựa chọn.
export const LIVE_OFFLINE_TEXT = "Bot đang ngoại tuyến — hình sẽ tự hiện lại khi bot trực tuyến";
const FPS_WINDOW_MS = 3000; // đếm khung trong 3 s gần nhất → khung/giây
const HE_SO_PHONG_TO = 3;
/** Từ số ô mở LỚN HƠN mức này (nhiều bot), ô ngoài khung nhìn hạ fps. Từ mức này trở xuống mọi ô chạy tốc độ thường. */
export const NGUONG_NHIEU_O = 12;
/** Ô đang ở trạng thái "có hình" nếu khung ảnh tốt gần nhất không quá lâu (khung lỗi / im lặng quá lâu → coi như không có hình). */
export const HINH_HET_HAN_MS = 10_000;
const CHAM_DO_TRE_MS = 400; // chờ trạng thái "ngoài khung nhìn" ổn định rồi mới báo máy chủ (thẻ vẽ lại tạm gỡ ô khỏi trang một thoáng)

interface ZoomO { wrap: HTMLElement; img: HTMLImageElement; err: HTMLElement; dong: () => void }
interface O {
  botId: string;
  el: HTMLElement;
  img: HTMLImageElement;
  err: HTMLElement;
  why: HTMLElement;
  fps: HTMLElement;
  stamps: number[];
  frames: number;
  offline: boolean;
  zoom: ZoomO | null;
  thongBao: HTMLElement; // lớp phủ chứa err + why (hiện khi một trong hai hiện)
  hinhLuc: number; // lúc nhận khung ảnh tốt gần nhất (0 = chưa có)
  coHinh: boolean; // đang có hình (khung tốt gần đây, bot trực tuyến)
  lastSrc: string; // khung tốt gần nhất — ô ngoài khung nhìn không vẽ, vào lại thì vẽ ngay khung này
  trongKhung: boolean; // IntersectionObserver: ô đang nằm trong khung nhìn
  cham: boolean; // đã báo máy chủ "ngoài khung nhìn"
  chamHen: number; // hẹn giờ báo
  an: HTMLElement | null; // nút "Ẩn" (chỉ hiện với ô bot của chủ khác, hoặc ô bot mình đang ngoại tuyến do người dùng mở theo liên kết)
  cuaMinh: boolean;
}

function khoPhien(): Pick<Storage, "getItem" | "setItem" | "removeItem"> | undefined {
  try { return window.sessionStorage; } catch { return undefined; }
}

export class XemHinh {
  /** Ô đang mở hình (theo mã bot). */
  readonly o = new Map<string, O>();
  /** Thứ tự bật (số tăng dần). */
  readonly batLuc = new Map<string, number>();
  readonly nho: NhoLuaChon;
  private seq = 0;
  private huy: (() => void)[] = [];
  /** Đã gọi hàm dọn của khoiDong() (rời trang): từ đó dongBo/moO không làm gì nữa. */
  private daDon = false;
  private quanSat: IntersectionObserver | null = null;
  /** Trang Bot đặt: ô đổi trạng thái "có hình" (khung đầu tiên tới / khung lỗi / quá lâu không có khung) → trang tính lại thứ tự thẻ. */
  khiHinhDoi: (() => void) | null = null;
  /** Trang Bot đặt: người dùng bấm "Ẩn" trên ô bot của chủ khác → vẽ lại thẻ ngay. */
  khiNguoiDungDoi: (() => void) | null = null;

  constructor(
    private readonly layBot: (id: string) => Bot | undefined,
    kho: Pick<Storage, "getItem" | "setItem" | "removeItem"> | undefined = khoPhien(),
    private readonly layNguoiDung: () => string | null = () => null,
  ) {
    this.nho = new NhoLuaChon(kho);
    // Phiên cũ (trước 06/10) có thể còn "off" / "Tắt hết hình" trong sessionStorage — giao diện mới không còn nút tắt, không để chúng khoá hình bot của mình.
    for (const [id, v] of this.nho.layTatCa()) if (v === "off" || id === KHOA_TAT_TU_BAT) this.nho.xoa(id);
    if (typeof IntersectionObserver !== "undefined") {
      this.quanSat = new IntersectionObserver((ds) => {
        for (const d of ds) {
          const botId = (d.target as HTMLElement).dataset.botId;
          const o = botId ? this.o.get(botId) : undefined;
          if (o && o.el === d.target) { o.trongKhung = d.isIntersecting; this.henCham(o); }
        }
      }, { rootMargin: "120px 0px" });
    }
  }

  get soO(): number { return this.o.size; }
  vung(botId: string): HTMLElement | null { return this.o.get(botId)?.el ?? null; }
  /** Người dùng bấm "Xem bot của <chủ>" trong khung màn hình (bot của Boss khác — không bao giờ tự mở). Nhớ trong phiên. */
  moTay(botId: string): void { this.nho.dat(botId, "on"); }
  /** Bot nào đang có hình (khung tốt gần đây) — để xếp bot có hình lên đầu. */
  hinhHienCo(): Map<string, boolean> { return new Map([...this.o].map(([id, o]) => [id, o.coHinh])); }

  /** Mở/đóng ô cho khớp danh sách mong muốn (đã chọn bằng chonOXem). Trả true nếu tập ô đổi. */
  dongBo(ids: string[]): boolean {
    if (this.daDon) return false; // đã rời trang: trả lời mạng/hẹn giờ muộn không được mở lại ô (sẽ rò watcher — bot cứ gửi hình khi không ai xem)
    const muon = new Set(ids);
    let doi = false;
    for (const id of [...this.o.keys()]) if (!muon.has(id)) { this.dongO(id); doi = true; }
    for (const id of ids) if (!this.o.has(id)) { this.moO(id); doi = true; }
    for (const id of this.o.keys()) this.veHienDien(id);
    return doi;
  }

  private moO(botId: string): void {
    if (this.daDon) return;
    const b = this.layBot(botId);
    const img = h("img", { alt: `Màn hình ${b?.name ?? botId}`, "data-testid": "live-img", draggable: "false" });
    const err = h("div", { class: "live-err", "data-testid": "live-error", hidden: true });
    const why = h("div", { class: "small live-why", "data-testid": "live-why", hidden: true });
    const thongBao = h("div", { class: "live-thong-bao", hidden: true }, err, why);
    const fps = h("span", { class: "tag may-osd", title: "Số khung hình nhận được mỗi giây; 0 = bot ngừng gửi hình", "data-testid": "live-fps" }, "chờ khung hình…");
    const phongTo = h("button", { type: "button", class: "bot-phong-to", title: `Phóng to màn hình bot này gấp ${HE_SO_PHONG_TO} lần để xem rõ (Esc để đóng)`, "aria-label": "Phóng to màn hình bot", "data-testid": "bot-phong-to", onclick: () => this.phongTo(botId) }, "⤢");
    // Bot CỦA MÌNH luôn mở hình, không có nút tắt. Chỉ ô của chủ khác (người dùng tự bấm mở) mới có nút "Ẩn" để đóng lại.
    const nguoi = this.layNguoiDung();
    const cuaMinh = !!nguoi && b?.ownerId === nguoi;
    const an = h("button", { type: "button", class: "mini may-an", title: "Ẩn hình bot này (không xem nữa)", "data-testid": "live-an", hidden: cuaMinh && (b?.online ?? false), onclick: () => this.anO(botId) }, "Ẩn");
    const el = h("div", { class: "bot-hinh", "data-testid": "bot-hinh", dataset: { botId } },
      h("div", { class: "live-shot" }, img, thongBao, fps, phongTo, an));
    const o: O = { botId, el, img, err, why, fps, stamps: [], frames: 0, offline: false, zoom: null, thongBao, hinhLuc: 0, coHinh: false, lastSrc: "", trongKhung: true, cham: false, chamHen: 0, an, cuaMinh };
    this.o.set(botId, o);
    this.batLuc.set(botId, ++this.seq);
    uiSocket.watch(botId, true);
    this.quanSat?.observe(el);
    this.veHienDien(botId);
    this.henChamSauDoiSoO(this.o.size - 1);
  }

  /** Ẩn ô bot của chủ khác (người dùng tự bấm mở trước đó) — quên lựa chọn, đóng ô. */
  private anO(botId: string): void {
    this.nho.xoa(botId);
    this.dongO(botId);
    this.khiNguoiDungDoi?.();
  }

  dongO(botId: string): void {
    const o = this.o.get(botId);
    if (!o) return;
    o.zoom?.dong();
    clearTimeout(o.chamHen);
    this.quanSat?.unobserve(o.el);
    if (o.cham) uiSocket.send({ type: "watch.cham", botId, cham: false });
    o.el.remove();
    this.o.delete(botId);
    this.batLuc.delete(botId);
    uiSocket.watch(botId, false);
    this.henChamSauDoiSoO(this.o.size + 1);
  }

  // ---- Nhiều ô: ô ngoài khung nhìn hạ fps ----
  /** Ô nên ở chế độ "chậm": đang mở > NGUONG_NHIEU_O ô và ô này nằm ngoài khung nhìn. */
  private nenCham(o: O): boolean { return this.o.size > NGUONG_NHIEU_O && !o.trongKhung; }
  private henCham(o: O): void {
    clearTimeout(o.chamHen);
    o.chamHen = window.setTimeout(() => this.ganCham(o), CHAM_DO_TRE_MS);
  }
  /** Số ô đổi từ `truoc`: chỉ khi vượt qua ngưỡng NGUONG_NHIEU_O (lên hoặc xuống) mới phải tính lại MỌI ô — tránh O(n²) hẹn giờ khi mở hàng trăm ô. */
  private henChamSauDoiSoO(truoc: number): void {
    // Cùng một phía của ngưỡng: ô mới tự được tính khi IntersectionObserver báo lần đầu; các ô cũ không đổi quyết định.
    if ((truoc > NGUONG_NHIEU_O) === (this.o.size > NGUONG_NHIEU_O)) return;
    for (const o of this.o.values()) this.henCham(o);
  }
  private ganCham(o: O): void {
    if (this.o.get(o.botId) !== o) return;
    const muon = this.nenCham(o);
    if (muon === o.cham) return;
    o.cham = muon;
    uiSocket.send({ type: "watch.cham", botId: o.botId, cham: muon });
    if (!muon && o.lastSrc) { o.img.src = o.lastSrc; if (o.zoom) o.zoom.img.src = o.lastSrc; } // vào lại khung nhìn: vẽ ngay khung gần nhất
  }
  /** Danh sách bot đang ở chế độ chậm (cho test / chẩn đoán). */
  get botDangCham(): string[] { return [...this.o.values()].filter((o) => o.cham).map((o) => o.botId); }

  private datCoHinh(o: O, v: boolean): void {
    if (o.coHinh === v) return;
    o.coHinh = v;
    this.khiHinhDoi?.();
  }
  private capNhatThongBao(o: O): void { o.thongBao.hidden = o.err.hidden && o.why.hidden; }

  /** Bot trực tuyến / ngoại tuyến → chữ trên ô: ngoại tuyến báo rõ (đè cả lỗi chụp cũ); trực tuyến lại về "chờ khung hình…" tới khi khung đầu tới. */
  veHienDien(botId: string): void {
    const o = this.o.get(botId);
    if (!o) return;
    const online = this.layBot(botId)?.online ?? false;
    if (!online) {
      o.offline = true;
      o.stamps = [];
      this.datLoi(o, LIVE_OFFLINE_TEXT);
      o.why.hidden = true;
      this.capNhatThongBao(o);
      o.el.classList.add("no-shot", "o-ngoai-tuyen");
      o.fps.textContent = "ngoại tuyến";
      this.datCoHinh(o, false);
    } else if (o.offline) {
      o.offline = false;
      o.frames = 0;
      this.datLoi(o, null);
      o.el.classList.remove("no-shot", "o-ngoai-tuyen");
      o.fps.textContent = "chờ khung hình…";
      this.capNhatThongBao(o);
    }
    const b = this.layBot(botId);
    if (b) o.img.alt = `Màn hình ${b.name}`;
    // Bot của MÌNH đang trực tuyến: luôn mở, không có nút nào để tắt. Ô của chủ khác, hoặc ô bot mình đang ngoại tuyến (mở theo liên kết): có nút "Ẩn".
    if (o.an) o.an.hidden = o.cuaMinh && online;
  }

  private datLoi(o: O, chu: string | null): void {
    if (chu === null) { o.err.hidden = true; if (o.zoom) o.zoom.err.hidden = true; this.capNhatThongBao(o); return; }
    o.err.textContent = chu;
    o.err.hidden = false;
    if (o.zoom) { o.zoom.err.textContent = chu; o.zoom.err.hidden = false; }
    this.capNhatThongBao(o);
  }

  onFrame(botId: string, jpegB64: string, error?: string): void {
    const o = this.o.get(botId);
    if (!o) return;
    o.offline = false; // có khung (kể cả khung lỗi) nghĩa là bot đang nối
    o.el.classList.remove("o-ngoai-tuyen");
    if (error || !jpegB64) {
      this.datLoi(o, error ? LIVE_ERROR_TEXT : "Không có hình");
      o.why.textContent = error ? `Lý do: ${error}` : "";
      o.why.hidden = !error;
      this.capNhatThongBao(o);
      o.el.classList.add("no-shot");
      o.fps.textContent = "không có khung";
      this.datCoHinh(o, false);
      return;
    }
    this.datLoi(o, null);
    o.why.hidden = true;
    this.capNhatThongBao(o);
    o.el.classList.remove("no-shot");
    // Đặt src MỖI khung (kể cả ảnh giống hệt khung trước — trang bot đứng yên): người xem thấy ảnh "sống", DOM đổi theo nhịp khung.
    // Ô ngoài khung nhìn (nhiều ô) chỉ nhớ khung, không vẽ — vào lại khung nhìn mới vẽ.
    const src = `data:image/jpeg;base64,${jpegB64}`;
    o.lastSrc = src;
    if (!o.cham || o.zoom) { o.img.src = src; if (o.zoom) o.zoom.img.src = src; }
    o.hinhLuc = Date.now();
    this.datCoHinh(o, true);
    o.frames++;
    const now = Date.now();
    o.stamps.push(now);
    while (o.stamps.length && now - o.stamps[0]! > FPS_WINDOW_MS) o.stamps.shift();
    this.veFps(o, now);
  }

  private veFps(o: O, now: number): void {
    if (!o.stamps.length) return;
    const span = Math.max(1000, now - o.stamps[0]!);
    const n = o.stamps.length >= 2 ? (o.stamps.length - 1) / (span / 1000) : o.stamps.length;
    o.fps.textContent = `${n < 10 ? n.toFixed(1) : Math.round(n)} khung/giây`;
  }

  /** Hộp phóng to: ảnh rộng gấp 3 lần ô (cuộn được nếu hơn khung nhìn), vẫn cập nhật khung liên tục; Esc / bấm nền / Đóng để đóng. */
  phongTo(botId: string): void {
    const o = this.o.get(botId);
    if (!o || o.zoom) return;
    const b = this.layBot(botId);
    const rong = Math.round((o.img.clientWidth || o.el.clientWidth || 400) * HE_SO_PHONG_TO);
    const img = h("img", { alt: `Màn hình ${b?.name ?? botId} (phóng to)`, "data-testid": "bot-zoom-img", draggable: "false", style: `width:${rong}px` });
    if (o.lastSrc || o.img.src) img.src = o.lastSrc || o.img.src;
    const err = h("div", { class: "live-err", "data-testid": "bot-zoom-error", hidden: true });
    let phim: (e: KeyboardEvent) => void = () => {};
    const dong = (): void => {
      document.removeEventListener("keydown", phim, true);
      wrap.remove();
      if (o.zoom && o.zoom.wrap === wrap) o.zoom = null;
    };
    phim = (e: KeyboardEvent): void => { if (e.key === "Escape") { e.preventDefault(); e.stopPropagation(); dong(); } };
    const wrap = h("div", { class: "modal-wrap bot-zoom-nen", role: "dialog", "aria-modal": "true", "aria-label": `Màn hình ${b?.name ?? botId} phóng to`, "data-testid": "bot-zoom" },
      h("div", { class: "bot-zoom-hop" },
        h("div", { class: "row bot-zoom-dau" }, h("b", { class: "grow wrap" }, b?.name ?? botId),
          h("button", { type: "button", class: "mini pri", title: "Đóng màn hình phóng to (hoặc nhấn Esc)", "data-testid": "bot-zoom-dong", onclick: dong }, "Đóng")),
        h("div", { class: "live-shot bot-zoom-anh" }, img, err)));
    // Bỏ qua cú bấm nền ngay sau khi mở (bấm đúp nút phóng to: cú bấm thứ hai rơi vào nền hộp mới hiện — không được đóng hộp).
    const moLuc = Date.now();
    wrap.addEventListener("click", (e) => { if (e.target === wrap && Date.now() - moLuc > 400) dong(); });
    wrap.addEventListener("dong-hop", dong); // đổi trang / Esc toàn cục (dongHopTrang)
    document.addEventListener("keydown", phim, true);
    document.body.appendChild(wrap);
    o.zoom = { wrap, img, err, dong };
    if (!o.err.hidden && o.err.textContent) { err.textContent = o.err.textContent; err.hidden = false; }
  }

  /** Nghe khung hình + nối lại WS + đếm khung/giây + tắt hết khi đóng tab. Trả hàm dọn (rời trang: tắt watch mọi ô, GIỮ lựa chọn tay). */
  khoiDong(): () => void {
    const offMsg = uiSocket.on((ev) => { if (ev.type === "frame") this.onFrame(ev.botId, ev.jpegB64, ev.error); });
    // WS rớt rồi nối lại → máy chủ đã quên watch (và báo "ngoài khung nhìn") của kết nối cũ → gửi lại cho mọi ô.
    let wasConnected = uiSocket.connected;
    const offState = uiSocket.onState((on) => {
      if (on && !wasConnected) for (const o of this.o.values()) { uiSocket.watch(o.botId, true); o.cham = false; this.henCham(o); }
      wasConnected = on;
    });
    // Nhãn khung/giây tự hạ về 0 khi khung ngừng tới; khung tốt quá lâu không tới → ô hết "có hình" (thẻ xuống dưới).
    const tick = window.setInterval(() => {
      const now = Date.now();
      for (const o of this.o.values()) {
        if (o.coHinh && now - o.hinhLuc > HINH_HET_HAN_MS) this.datCoHinh(o, false);
        while (o.stamps.length && now - o.stamps[0]! > FPS_WINDOW_MS) o.stamps.shift();
        if (!o.stamps.length && o.frames && o.err.hidden) o.fps.textContent = "0 khung/giây";
        else if (o.stamps.length) this.veFps(o, now);
      }
    }, 1000);
    const onUnload = (): void => { for (const id of this.o.keys()) uiSocket.watch(id, false); };
    window.addEventListener("beforeunload", onUnload);
    const don = (): void => {
      this.daDon = true;
      offMsg();
      offState();
      clearInterval(tick);
      window.removeEventListener("beforeunload", onUnload);
      for (const id of [...this.o.keys()]) { const o = this.o.get(id); o?.zoom?.dong(); if (o) clearTimeout(o.chamHen); uiSocket.watch(id, false); }
      this.quanSat?.disconnect();
      this.o.clear();
      this.batLuc.clear();
    };
    this.huy.push(don);
    return don;
  }
}
